import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    name?: string;
    type?: string;
    image?: string;
    url?: string;
    keywords?: string[];
    schema?: Record<string, unknown>;
    noindex?: boolean;
}

export const SEO = ({
    title = "Peru IA - Elecciones 2026",
    description = "Chatea con nuestra IA y conoce las propuestas de todos los candidatos para las elecciones de Peru 2026. Informacion neutral y verificada.",
    name = "Peru IA",
    type = "website",
    image = "https://peruhonesto.com/logo.png",
    url = "https://peruhonesto.com/",
    keywords = [
        "elecciones peru 2026",
        "candidatos presidenciales",
        "peru ia",
        "inteligencia artificial",
        "voto informado peru",
        "propuestas presidenciales peru"
    ],
    schema,
    noindex = false
}: SEOProps) => {
    const defaultSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": name,
        "url": url,
        "description": description,
        "inLanguage": "es",
        "publisher": {
            "@type": "Organization",
            "name": "Peru IA",
            "url": "https://peruhonesto.com",
            "logo": {
                "@type": "ImageObject",
                "url": image
            }
        }
    };

    const finalSchema = schema || defaultSchema;

    return (
        <Helmet>
            {/* Standard metadata */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords.join(', ')} />
            <link rel="canonical" href={url} />

            {/* Robots */}
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow" />
            )}

            {/* OpenGraph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content={name} />
            <meta property="og:locale" content="es_PE" />

            {/* Twitter */}
            <meta name="twitter:creator" content="@peru_ia" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* JSON-LD Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(finalSchema)}
            </script>
        </Helmet>
    );
};
